<template>
  <div class="login"></div>
</template>
<script>
import { getToken, setToken } from "../token";
export default {
  data() {
    return {};
  },
  created() {
    if (getToken()) {
      this.$router.push(this.$route.query.redirect);
    } else {
      let code = this.$route.query.code;
      if (code) {
        this.$axios.get("/book/login?code=" + code).then((res) => {
          setToken(res.data.token);
          this.$router.push(this.$route.query.redirect);
        });
      } else {
        let url;
        url = "/book/redirectUrl?url=" + window.location.href;
        this.$axios.get(url).then((res) => {
          window.location.href = res.data;
        });
      }
    }
  },
};
</script>
<style scoped>
.login {
  width: 100%;
  height: 100%;
  background: #fff;
}
</style>